import React, { useEffect, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeart } from '@fortawesome/free-solid-svg-icons';

function Footer() {
    const [date, setDate] = useState(new Date().getFullYear());    

    return (
        <React.Fragment>
            <footer className="footer pt-3  ">
                <div className="container-fluid">
                    <div className="row align-items-center justify-content-lg-between">
                        <div className="col-lg-6 mb-lg-0 mb-4">
                            <div className="copyright text-center text-sm text-muted text-lg-start">
                                © {date},
                                made with <FontAwesomeIcon icon={faHeart} /> by
                                <a href="https://www.md3verse.com" className="font-weight-bold" target="_blank"> MD3 Verse </a>
                                for a better web.
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </React.Fragment>
    )
}

export default Footer